
<ng-container *ngIf="!isLoading;">
  <ng-container *ngComponentOutlet="currentComponent; inputs: componentInputs"></ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loading-spinner">
    <p>Cargando configuración...</p>
  </div>
</ng-template>